__turbopack_context__.v({
  "card": "teamcard-module-scss-module__GHmtYa__card",
  "cardContainer": "teamcard-module-scss-module__GHmtYa__cardContainer",
  "heroRightColumn": "teamcard-module-scss-module__GHmtYa__heroRightColumn",
  "link": "teamcard-module-scss-module__GHmtYa__link",
  "sportsCard": "teamcard-module-scss-module__GHmtYa__sportsCard",
  "sportsCardWrapper": "teamcard-module-scss-module__GHmtYa__sportsCardWrapper",
  "teamHeroLogo": "teamcard-module-scss-module__GHmtYa__teamHeroLogo",
});
